var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type == 'inline' ? 'loading-inline' : 'loading-block',style:({
    height: _vm.$props.height,
  })},[_c('div',{staticClass:"loading_blob",style:({ backgroundColor: _vm.color })}),_vm._v(" "),_c('div',{staticClass:"loading_blob",style:({ backgroundColor: _vm.color })}),_vm._v(" "),_c('div',{staticClass:"loading_blob",style:({ backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }